/* tt-home.js — behaviours for the Tank Teez home page bundle.
   Carousels, colorway toggle, size picker, cart, reveals, sticky bar. */
(function () {
  'use strict';


  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* bind once per element, so init() is safe to re-run (theme editor redraws) */
  function once(el, key) {
    var k = 'ttb' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ---- reveals ----
     GSAP ScrollTrigger.batch when available: batched entrances stagger together
     instead of every element firing on its own, which reads as one deliberate
     motion rather than a scatter. IntersectionObserver stays as the fallback,
     and a hard timeout guarantees nothing is ever left invisible. */
  /* the failsafe must clear GSAP's inline opacity too — a class can never
     override an inline style, so a class-only fallback silently does nothing */
  function revealAll() {
    $$('.tth-reveal:not(.tth-hero-photo)').forEach(function (e) {
      if (window.gsap) gsap.set(e, { opacity: 1, y: 0, clearProps: 'transform' });
      else { e.style.opacity = '1'; e.style.transform = 'none'; }
      e.classList.add('tth-in');
    });
  }

  function reveals() {
    var els = $$('.tth-reveal').filter(function (e) { return !e.classList.contains('tth-hero-photo'); });
    if (!els.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { revealAll(); return; }

    /* show anything at or above the fold immediately — scrolling fast must never
       land you on a section that is still fading in */
    function catchUp() {
      els.forEach(function (e) {
        if (e.classList.contains('tth-in')) return;
        if (e.getBoundingClientRect().top < window.innerHeight * 0.98) {
          if (window.gsap) gsap.set(e, { opacity: 1, y: 0, clearProps: 'transform' });
          e.classList.add('tth-in');
        }
      });
    }

    var sweeping = false;
    window.addEventListener('scroll', function () {
      if (sweeping) return;
      sweeping = true;
      requestAnimationFrame(function () { catchUp(); sweeping = false; });
    }, { passive: true });

    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      var fresh = els.filter(function (e) { return once(e, 'rev'); });
      if (fresh.length) {
        gsap.set(fresh, { opacity: 0, y: 18 });
        ScrollTrigger.batch(fresh, {
          start: 'top 96%',
          once: true,
          fastScrollEnd: true,
          onEnter: function (batch) {
            batch.forEach(function (e) { e.classList.add('tth-in'); });
            gsap.to(batch, {
              opacity: 1, y: 0,
              duration: .42,
              ease: 'power2.out',
              stagger: { each: .05, amount: Math.min(batch.length * .05, .18) },
              overwrite: true,
              onComplete: function () {
                batch.forEach(function (e) {
                  e.classList.add('tth-in');
                  e.style.transform = '';
                });
              }
            });
          }
        });
      }
      catchUp();
      setTimeout(revealAll, 1200);
      return;
    }

    /* fallback: no GSAP */
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    catchUp();
    setTimeout(revealAll, 1500);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('tth-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.02 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- product image carousel ---- */
  function carousels() {
    $$('.tth-carousel').forEach(function (car) {
      if (!once(car, 'car')) return;
      var slides = $$('.tth-slide', car);
      if (slides.length < 2) return;
      var dots = $$('.tth-carousel-dots .tth-dot', car);
      var thumbs = $$('.tth-thumb-row img', car.parentNode);
      var i = 0, timer = null;
      var delay = parseInt(car.getAttribute('data-interval'), 10) || 4000;

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('tth-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('tth-active', k === i); });
        thumbs.forEach(function (t) {
          t.classList.toggle('tth-active', (parseInt(t.getAttribute('data-index'), 10) || 0) === i);
        });
      }
      function play() { stop(); timer = setInterval(function () { go(i + 1); }, delay); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      slides[0].classList.add('tth-active');
      dots.forEach(function (d, k) {
        if (once(d, 'dot')) d.addEventListener('click', function () { go(k); play(); });
      });
      thumbs.forEach(function (t) {
        if (!once(t, 'thumb')) return;
        t.addEventListener('click', function () {
          go(parseInt(t.getAttribute('data-index'), 10) || 0); play();
        });
      });
      car.addEventListener('mouseenter', stop);
      car.addEventListener('mouseleave', play);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
    });
  }

  /* ---- colorway toggle ---- */
  function toggles() {
    var btns = $$('[data-tt-toggle]');
    if (!btns.length) return;
    function show(id) {
      $$('[data-tt-panel]').forEach(function (p) {
        p.classList.toggle('tth-active', p.getAttribute('data-tt-panel') === id);
      });
      btns.forEach(function (b) {
        var on = b.getAttribute('data-tt-toggle') === id;
        b.classList.toggle('tth-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    btns.forEach(function (b) {
      if (once(b, 'tog')) b.addEventListener('click', function () { show(b.getAttribute('data-tt-toggle')); });
    });
    /* hero / nav links that jump to a specific colorway */
    $$('[data-color-link]').forEach(function (a) {
      if (!once(a, 'clink')) return;
      a.addEventListener('click', function () {
        var want = (a.getAttribute('data-color-link') || '').toLowerCase();
        var match = btns.filter(function (b) {
          return b.textContent.trim().toLowerCase() === want;
        })[0];
        if (match) show(match.getAttribute('data-tt-toggle'));
      });
    });
  }

  /* ---- size picker keeps the buy button in sync ---- */
  function sizes() {
    $$('[data-tt-panel]').forEach(function (panel) {
      var atc = panel.querySelector('[data-tt-atc]');
      var priceEl = panel.querySelector('[data-tt-price]');
      $$('.tth-size', panel).forEach(function (btn) {
        if (!once(btn, 'size')) return;
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('disabled')) return;
          $$('.tth-size', panel).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          if (atc) atc.setAttribute('data-tt-variant-id', btn.getAttribute('data-tt-variant'));
          var p = btn.getAttribute('data-tt-price');
          if (priceEl && p) {
            var cmp = priceEl.querySelector('.tth-compare');
            priceEl.firstChild.nodeValue = p + ' ';
            if (cmp) priceEl.appendChild(cmp);
          }
        });
      });
    });
  }

  /* ---- add to cart ---- */
  function addToCart(items, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      if (btn) { btn.textContent = 'Added ✓'; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); }
      else { window.location.href = '/cart'; }
    }).catch(function () {
      window.location.href = '/cart';
    }).then(function () {
      if (btn) { setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600); }
    });
  }

  function cart() {
    $$('[data-tt-atc]').forEach(function (btn) {
      if (!once(btn, 'atc')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-tt-variant-id');
        if (!id) return;
        addToCart([{ id: Number(id), quantity: 1 }], btn);
      });
    });
    $$('[data-tt-bundle]').forEach(function (btn) {
      if (!once(btn, 'bun')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var ids = (btn.getAttribute('data-tt-bundle') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        addToCart(ids.map(function (i) { return { id: Number(i), quantity: 1 }; }), btn);
      });
    });
  }

  /* ---- sticky bar: concept reveals it once the jersey section scrolls past the top ---- */
  function sticky() {
    var bar = document.querySelector('.tth-sticky-cta');
    var jersey = document.getElementById('tt-jersey');
    if (!bar || !jersey || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('tth-show', e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(jersey);
  }

  /* ---- hero parallax ----
     GSAP ScrollTrigger with scrub, so the photo is tied to scroll position
     rather than chasing it. The image inside keeps its CSS ambient zoom —
     GSAP moves the container, so the two never touch the same property.
     Falls back to a rAF scroll handler if GSAP fails to load. */
  function parallax() {
    var photo = document.querySelector('.tth-hero-photo');
    var hero = document.querySelector('.tth-hero');
    if (!photo || !hero || !once(photo, 'plx')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* stacked mobile hero has no room to absorb the shift — it would ride over
       the seam bar below it, so parallax is desktop-only */
    if (window.innerWidth < 750) return;

    var shift = parseFloat(photo.getAttribute('data-parallax')) || 60;

    /* if GSAP has not arrived yet, retry once it has rather than silently
       settling for the fallback */
    if (!(window.gsap && window.ScrollTrigger)) {
      window.addEventListener('load', function () {
        if (window.gsap && window.ScrollTrigger && !photo.dataset.ttbplxGsap) {
          photo.dataset.ttbplxGsap = '1';
          photo.style.transform = '';
          gsap.registerPlugin(ScrollTrigger);
          gsap.fromTo(photo, { y: 0 }, {
            y: shift, ease: 'none',
            scrollTrigger: { start: 0, end: shift / 0.08, scrub: 0.35, invalidateOnRefresh: true }
          });
          ScrollTrigger.refresh();
        }
      });
    }

    if (window.gsap && window.ScrollTrigger) {
      photo.dataset.ttbplxGsap = '1';
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(photo,
        { y: 0 },
        {
          y: shift,
          ease: 'none',
          scrollTrigger: { start: 0, end: shift / 0.08, scrub: 0.35, invalidateOnRefresh: true }
        }
      );
      window.addEventListener('load', function () { ScrollTrigger.refresh(); });
      return;
    }

    /* fallback: no GSAP */
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        photo.style.transform = 'translate3d(0,' + Math.min(window.scrollY * 0.08, shift) + 'px,0)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- stylist quiz chips ---- */
  function quiz() {
    var chips = $$('.tth-quiz-chip');
    if (!chips.length) return;
    var out = document.querySelector('[data-tt-quiz-result]');
    chips.forEach(function (c) {
      if (!once(c, 'chip')) return;
      c.addEventListener('click', function () {
        chips.forEach(function (o) { o.classList.remove('tth-active'); });
        c.classList.add('tth-active');
        if (out) {
          out.innerHTML = '<div class="tth-eyebrow">// matched</div><h3>' +
            (c.getAttribute('data-tt-answer') || c.textContent.trim()) + '</h3>';
        }
      });
    });
  }


  /* ---- Tank AI chat (canned answers, driven by section blocks) ---- */
  function chat() {
    var launcher = document.getElementById('tth-ai-launcher');
    var panel = document.getElementById('tth-ai-panel');
    if (!launcher || !panel || !once(launcher, 'chat')) return;
    var closeBtn = document.getElementById('tth-ai-close');
    var msgs = document.getElementById('tth-ai-messages');
    var input = document.getElementById('tth-ai-input');
    var send = document.getElementById('tth-ai-send');
    var quick = document.getElementById('tth-quick-replies');
    var kbEl = document.getElementById('tth-ai-kb');
    var kb = [];
    try { kb = JSON.parse(kbEl.textContent) || []; } catch (e) { kb = []; }
    var greeted = false;

    function add(text, who) {
      var d = document.createElement('div');
      d.className = 'tth-msg tth-' + who;
      d.textContent = text;
      msgs.appendChild(d);
      msgs.scrollTop = msgs.scrollHeight;
    }
    function typing(on) {
      var t = document.getElementById('tth-typing');
      if (on) {
        if (t) return;
        var d = document.createElement('div');
        d.className = 'tth-msg tth-bot tth-typing';
        d.id = 'tth-typing';
        d.innerHTML = '<span class="tth-typing-dots"><span></span><span></span><span></span></span>';
        msgs.appendChild(d);
        msgs.scrollTop = msgs.scrollHeight;
      } else if (t) { t.remove(); }
    }
    function reply(msg) {
      var m = msg.toLowerCase();
      for (var i = 0; i < kb.length; i++) {
        var keys = String(kb[i].k || '').split(',');
        for (var j = 0; j < keys.length; j++) {
          var k = keys[j].trim().toLowerCase();
          if (k && m.indexOf(k) !== -1) return kb[i].a;
        }
      }
      return panel.getAttribute('data-fallback');
    }
    function handle(text) {
      var t = (text || '').trim();
      if (!t) return;
      add(t, 'user');
      if (input) input.value = '';
      typing(true);
      setTimeout(function () { typing(false); add(reply(t), 'bot'); }, 650);
    }

    function toggle() {
      var open = panel.classList.toggle('tth-open');
      launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && !greeted) {
        greeted = true;
        add(panel.getAttribute('data-greeting'), 'bot');
      }
      if (open && input) input.focus();
    }
    launcher.addEventListener('click', toggle);
    if (closeBtn) closeBtn.addEventListener('click', function () {
      panel.classList.remove('tth-open');
      launcher.setAttribute('aria-expanded', 'false');
      launcher.focus();
    });
    if (send) send.addEventListener('click', function () { handle(input.value); });
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handle(input.value); }
    });
    if (quick) quick.addEventListener('click', function (e) {
      var b = e.target.closest('.tth-qr-btn');
      if (b) handle(b.getAttribute('data-q'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('tth-open')) {
        panel.classList.remove('tth-open');
        launcher.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Lenis smooth scroll ----
     Driven off gsap.ticker (not its own rAF) so ScrollTrigger and the parallax
     stay in perfect sync — two independent loops would fight and jitter.
     Kept light: this should smooth the scroll, not take it over. */
  function smoothScroll() {
    if (!window.Lenis || !window.gsap) return;
    if (window.__ttLenis) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;   /* leave native inertia alone on touch */

    var lenis = new Lenis({
      duration: 0.9,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.6
    });
    window.__ttLenis = lenis;

    if (window.ScrollTrigger) {
      lenis.on('scroll', ScrollTrigger.update);
      ScrollTrigger.scrollerProxy(document.body, {});
    }
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);

    /* in-page anchors go through Lenis so they ease instead of jumping */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var id = href.split('#')[1];
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -90, duration: 1.1 });
    });
  }

  /* ---- keyboard activation for non-native controls ----
     Any element we expose as role="button" (carousel dots, gallery thumbs,
     stylist quiz chips) must answer Enter and Space like a real button does.
     One delegated handler covers every such control, present and future. */
  function keyActivation() {
    if (!once(document.documentElement, 'keyact')) return;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var el = e.target;
      if (!el || !el.getAttribute) return;
      if (el.getAttribute('role') !== 'button') return;
      if (el.tagName === 'BUTTON' || el.tagName === 'A') return;
      e.preventDefault();
      el.click();
    });
  }

  function init() { reveals(); carousels(); toggles(); sizes(); cart(); sticky(); parallax(); smoothScroll(); quiz(); chat(); keyActivation(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* re-init inside the theme editor when a section is redrawn */
  document.addEventListener('shopify:section:load', init);
})();
